import { render, staticRenderFns } from "./P0220.vue?vue&type=template&id=8f0089fa&"
import script from "./P0220.vue?vue&type=script&lang=ts&"
export * from "./P0220.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports